import type { ResidentRow } from "../types"

/**
 * State for the residents table "select all" checkbox (transfer_resident / split_property).
 * When unchecked, `selectAllChecked` must be false so pagination does not re-select every
 * row (Angular parity; see transfer-feature-documentation D2).
 */
export function getSelectAllResidentSelectionState(
  checked: boolean,
  residents: ResidentRow[],
): { selectedIds: number[]; selectAllChecked: boolean } {
  if (checked) {
    return {
      selectedIds: residents.map((r) => r.application_id),
      selectAllChecked: true,
    }
  }
  return { selectedIds: [], selectAllChecked: false }
}
